import React, { useEffect, useState } from "react";
import { Button, Input } from "antd";

const DEFAULT_OTP_LENGTH = 6;

/**
 * Step 2 of secure deletion: enter and verify the OTP.
 */
export default function SecureDeleteOtp({
  entityType = "item",
  otpLength = DEFAULT_OTP_LENGTH,
  loading = false,
  resendLoading = false,
  errorMessage = "",
  onCancel,
  onVerify,
  onResend,
}) {
  const [otp, setOtp] = useState("");

  useEffect(() => {
    setOtp("");
  }, []);

  const isComplete = otp.length === otpLength;

  const handleOtpChange = (e) => {
    const digitsOnly = (e.target.value || "").replace(/\D/g, "").slice(0, otpLength);
    setOtp(digitsOnly);
  };

  const handleVerify = () => {
    if (!isComplete || loading) return;
    onVerify?.(otp);
  };

  return (
    <div className="secure-delete-otp">
      <h2 className="secure-delete-title">Verify OTP</h2>
      <p className="secure-delete-description">
        A verification code has been sent to the authorized administrator.
      </p>
      <p className="secure-delete-otp-hint">
        OTP verification is required to complete {entityType} deletion.
      </p>

      <label className="secure-delete-label" htmlFor="secure-delete-otp-input">
        Enter OTP
      </label>
      <Input
        id="secure-delete-otp-input"
        className="secure-delete-input"
        value={otp}
        onChange={handleOtpChange}
        placeholder={`${otpLength}-digit code`}
        inputMode="numeric"
        maxLength={otpLength}
        disabled={loading || resendLoading}
        autoFocus
        aria-invalid={Boolean(errorMessage)}
        aria-describedby={errorMessage ? "secure-delete-otp-error" : undefined}
        onPressEnter={handleVerify}
      />
      {errorMessage ? (
        <p id="secure-delete-otp-error" className="secure-delete-error" role="alert">
          {errorMessage}
        </p>
      ) : null}

      <div className="secure-delete-actions">
        <Button
          className="secure-delete-cancel-btn"
          onClick={onCancel}
          disabled={loading || resendLoading}
        >
          Cancel
        </Button>
        <Button
          className="secure-delete-verify-btn"
          onClick={handleVerify}
          disabled={!isComplete || loading || resendLoading}
          loading={loading}
        >
          Verify OTP
        </Button>
      </div>

      {onResend ? (
        <div className="secure-delete-resend">
          Didn&apos;t receive the code?{" "}
          <Button
            type="link"
            className="secure-delete-resend-btn"
            onClick={onResend}
            disabled={loading || resendLoading}
            loading={resendLoading}
          >
            Resend OTP
          </Button>
        </div>
      ) : null}
    </div>
  );
}
